<template>
    <v-btn
        :id="gtmTrackerId"
        outlined
        :small="$vuetify.breakpoint.xs"
        class="habiteo-btn outlined text-capitalize promoter-customization"
        :class="{
            'xs': $vuetify.breakpoint.xs
        }"
        @click="switchWidget"
    >
        <v-icon
            class="icon"
            :left="!$vuetify.breakpoint.xs"
            :class="widget === 'plot-grid' ? 'icon-rotation' : 'icon-list-dashes'"
        />
        <span
            v-if="!$vuetify.breakpoint.xs"
            class="habiteo-body-2"
        > 
            {{ widget === 'plot-grid' ? $t('cutawayHeader.toggleViewBtn.threeDView') : $t('cutawayHeader.toggleViewBtn.plotGrid') }}
        </span>
    </v-btn>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    export default {
        name: "ToggleViewButton",
        props: {
            widget: {
                type: String,
                require: true
            },
            isOpenedSidebar: {
                type: Boolean,
                require: true
            }
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'protocol'
            ]),
            gtmTrackerId() {
                let widget = this.widgetType === 'plot-grid' ? 'cutaway' : 'plot-grid';
                return `gtm-switch-cta-${widget}`;
            },
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        data: () => ({
            widgetType: null
        }),
        created() {
            this.widgetType = this.$props.widget;
        },
        methods: {
            switchWidget() {
                this.widgetType = this.$props.widget === 'plot-grid' ? 'cutaway' : 'plot-grid';
                EventBus.$emit('updateLoadedWidgets', {
                    id: this.widgetType,
                    link: this.apiUrl  + '/request-data/cutaway-view' + window.location.search,
                    active: true,
                    widgetType: this.widgetType
                });
                EventBus.$emit('switchSidebar', this.widgetType);
            }
        }
    }
</script>

<style lang="scss">
    @import '@/assets/scss/components/_habiteo-button.scss';
</style>


// WEBPACK FOOTER //
// src/components/cutawayHeader/components/ToggleViewButton.vue